export default __webpack_public_path__ + "static/media/cv-book-new.436ebbc3.png";